module.exports = __webpack_public_path__ + "68d6dabfe54e245e7d5d5c16c3c4b1a9.woff";